import DragAndDropContainer from './DragAndDropContainer'
import {DragAndDropItem} from './DragAndDropItem'
import {DragAndDropMoveDialog} from './DragAndDropMoveDialog'
import {DragAndDropTrigger} from './DragAndDropTrigger'
import {MoveDialog} from './MoveDialog/MoveDialog'
import {MoveDialogForm} from './MoveDialog/MoveDialogForm'
import {MoveDialogTrigger} from './MoveDialog/MoveDialogTrigger'

/**
 * Wrapper for the sortable list and item components.
 */
export const DragAndDrop = Object.assign(DragAndDropContainer, {
  Item: DragAndDropItem,
  DragTrigger: DragAndDropTrigger,
  MoveDialog,
  MoveDialogForm,
  MoveDialogTrigger,
  DragAndDropMoveDialog,
})

try{ DragAndDrop.displayName ||= 'DragAndDrop' } catch {}